import { useEffect, useLayoutEffect, useState } from "react";
import {
  Box,
  Button,
  Grid,
  TextField,
  Tooltip,
  useMediaQuery,
} from "@mui/material";
import ValidationError from "../../../../components/validation-error-label";
import AddIcon from "@mui/icons-material/Add";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import Color from "../../../../theme/color";
import { POST } from "../../../../config/https";
import APIS from "../../../../config/api";
import { usePersistentState } from "../../../../contexts/global-context";
import { GetLocalStorage } from "../../../../utils/local-storage";
import { isEmpty } from "../../../../utils/validator";
import FullScreenLoader from "../../../../components/full-screen-loader";

const EventFaq = () => {
  const [state, dispatch]: any = usePersistentState();

  const [eventFaq, setEventFaq] = useState<
    {
      title: string;
      description: string;
      ordering: string;
      id?: string;
      isDisabled: boolean;
    }[]
  >([{ title: "", description: "", ordering: "", id: "", isDisabled: false }]);
  const [isValidation, setIsValidation] = useState(false);
  const [formErrors, setFormErrors] = useState<Record<string, string>>({});
  const isMobile = useMediaQuery((theme: any) => theme.breakpoints.down("sm"));
  // useEffect(() => {
  //   if (isValidation) {
  //     // validator();
  //   }
  // }, [eventFaq, isValidation]);
  useLayoutEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);
  useEffect(() => {
    if (state.WizardKey === 3 && state.AddEventType === "AddEventFaq") {
      // setIsValidation(true);
      // if (!validator()) {
      //   dispatch({
      //     AddEventType: "",
      //   });
      //   return;
      // }
      AddMethod();
    }
  }, [state.WizardKey, state.AddEventType, state.toggleState]);

  useEffect(() => {
    if (state.WizardKey === 3) {
      let temp: any = GetLocalStorage("eventFaq");

      if (temp === null || temp?.length === 0) {
        temp = null;
      } else {
        temp = GetLocalStorage("eventFaq");
      }
      if (temp) {
        let newData: {
          title: string;
          description: string;
          ordering: string;
          isDisabled: boolean;
        }[] = temp?.map((x: any) => {
          return {
            title: x?.title,
            description: x?.description,
            eventId: x?.eventId,
            ordering: x?.ordering,
            id: x?.id,
            isDisabled: x?.isDisabled,
          };
        });
        setEventFaq(newData);
      }
    }
  }, [state.WizardKey]);

  const AddMethod = async () => {
    let isSuccess = await AddEventFaq();
    if (isSuccess) {
      dispatch({ WizardKey: state.WizardKey + 1, AddEventType: "" });
    }
  };
  const showRemoveButton = (index: number) => {
    if (eventFaq.length === 1) {
      return false;
    }
    if (eventFaq.length - 1 === index) {
      return false;
    }
    return true;
  };
  const AddEventFaq = async () => {
    dispatch({ FullScreenLoader: true });
    let tempData: any = localStorage.getItem("eventDetails");
    let eventId = JSON.parse(tempData);

    const temp = eventFaq.filter(
      (obj) => obj.title.trim() !== "" || obj.description.trim() !== ""
    );

    let tempParam = temp?.map((x: any) => {
      return {
        eventId: eventId?.id,
        title: x?.title,
        description: x?.description,
        id: x?.id,
        ordering: x?.ordering || null,
        isDisabled: x?.isDisabled,
      };
    });
    let param = {
      eventId: eventId?.id,
      eventFaq: tempParam,
    };
    try {
      const res: any = await POST(APIS.ADD_EVENT_FAQ, param);
      if (res?.isSuccess) {
        localStorage.setItem("eventFaq", JSON.stringify(res?.result));
        if (state.FilledSteps[state.FilledSteps.length - 4] < 5) {
          const updatedSteps = state.FilledSteps.includes(4)
            ? [...state.FilledSteps]
            : [...state.FilledSteps, 4];
          dispatch({ FilledSteps: updatedSteps });
        }
        return true;
      } else {
        return false;
      }
    } catch (error) {
      console.error(error);
    } finally {
      dispatch({ FullScreenLoader: false });
      // setIsValidation(false);
    }
  };

  const handleChangeInputFaq = (index: number, event: any) => {
    const values: any = [...eventFaq];
    values[index][event.target.name] = event.target.value;
    setEventFaq(values);
  };
  // const handleRemoveFieldsFaq = (index: number) => {
  //   const values = [...eventFaq];
  //   values[index] = {
  //     ...values[index],
  //     isDisabled: true,
  //   };
  //   setEventFaq(values);
  // };

  const handleRemoveFieldsFaq = (index: number) => {
    const values = [...eventFaq];

    if (index >= 0 && index < values.length) {
      values.splice(index, 1);

      setEventFaq(values);
    } else {
      console.log("Invalid index");
    }
  };

  const handleAddFieldsFaq = () => {
    setEventFaq([
      ...eventFaq,
      { title: "", description: "", ordering: "", id: "", isDisabled: false },
    ]);
  };
  const showAddButtonFaq = (index: number) => {
    if (eventFaq.length === 1) {
      return true;
    }
    if (eventFaq.length - 1 === index) {
      return true;
    }
    return false;
  };

  const renderAddRemoveIngredient = (index: number) => {
    return (
      <Grid item xs={12} sm={2} md={1}>
        {showAddButtonFaq(index) && (
          <Button
            onClick={handleAddFieldsFaq}
            color="primary"
            variant="contained"
            style={{
              backgroundColor: Color.green,
              width: isMobile ? "95.5%" : "100%",
              // marginBottom: 5,
              margin: "3px",
            }}
          >
            <AddIcon />
          </Button>
        )}
        {showRemoveButton(index) ? (
          <Button
            onClick={() => handleRemoveFieldsFaq(index)}
            color="primary"
            variant="contained"
            style={{
              backgroundColor: Color.red,
              margin: "3px",
              width: isMobile ? "95.5%" : "100%",
            }}
          >
            <DeleteForeverIcon />
          </Button>
        ) : (
          <>
            {showRemoveButton(index) === showRemoveButton(0) ? null : (
              <Button
                onClick={() => handleRemoveFieldsFaq(index)}
                color="primary"
                variant="contained"
                style={{
                  backgroundColor: Color.red,
                  margin: "3px",
                  width: isMobile ? "95.5%" : "100%",
                }}
              >
                <DeleteForeverIcon />
              </Button>
            )}
          </>
        )}
      </Grid>
    );
  };

  // const validator = () => {
  //   const errors: Record<string, string> = {};

  //   eventFaq?.forEach((faq, index) => {
  //     if (isEmpty(faq.title)) {
  //       errors[`title-${index}`] = "Title is required";
  //     }

  //     if (isEmpty(faq.description)) {
  //       errors[`description-${index}`] = "Description is required";
  //     }

  //     if (!faq.ordering) {
  //       errors[`ordering-${index}`] = "Ordering is required";
  //     } else if (!/^\d+$/.test(faq.ordering) || parseInt(faq.ordering) <= 0) {
  //       errors[`ordering-${index}`] = "Ordering should be a positive integer";
  //     }
  //   });

  //   setFormErrors(errors);
  //   return Object.keys(errors).length === 0;
  // };
  return (
    <div style={{ width: "100%", marginTop: 70 }}>
      <Box
        style={{
          width: "100%",
        }}
      >
        <FullScreenLoader open={state.FullScreenLoader} />
        {eventFaq?.map((inputField: any, index: number) => {
          if (inputField?.isDisabled === true) return;
          return (
            <Grid
              sx={{
                width: "100%",
                justifyContent: "space-between",
                flexDirection: "row",
                marginBottom: eventFaq.length - 1 === index ? 0 : 2,
                marginTop: index === 0 ? 0 : 5,
              }}
              container
              columns={{ xs: 12, sm: 12, md: 12 }}
              key={index}
            >
              <Grid
                container
                xs={12}
                sm={12}
                md={11}
                spacing={{ xs: 1, md: 1 }}
              >
                <Grid item xs={12} sm={12} md={9}>
                  <TextField
                    id="startDate"
                    size="small"
                    placeholder="Title"
                    label="Title"
                    name="title"
                    style={{ width: "100%" }}
                    value={inputField.title}
                    onChange={(event: any) =>
                      handleChangeInputFaq(index, event)
                    }
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />

                  {/* {formErrors[`title-${index}`] && (
                    <ValidationError
                      formErrors={formErrors[`title-${index}`]}
                    />
                  )} */}
                </Grid>
                <Grid item xs={12} sm={12} md={3}>
                  <Tooltip
                    title="Order in which you want to display different FAQs"
                    placement="top-start"
                  >
                    <TextField
                      id="Ordering"
                      size="small"
                      placeholder="Ordering"
                      label="Ordering"
                      type="number"
                      name="ordering"
                      style={{ width: "100%" }}
                      value={inputField.ordering}
                      onChange={(event: any) =>
                        handleChangeInputFaq(index, event)
                      }
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </Tooltip>
                  {/* {formErrors[`ordering-${index}`] && (
                    <ValidationError
                      formErrors={formErrors[`ordering-${index}`]}
                    />
                  )} */}
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <TextField
                    id="startDate"
                    size="small"
                    placeholder="Description"
                    label="Description"
                    name="description"
                    maxRows={20}
                    rows={3}
                    style={{
                      width: "100%",
                      resize: "vertical",
                      marginTop: 5,
                    }}
                    value={inputField.description}
                    multiline={true}
                    onChange={(event: any) =>
                      handleChangeInputFaq(index, event)
                    }
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                  {/* {formErrors[`description-${index}`] && (
                    <ValidationError
                      formErrors={formErrors[`description-${index}`]}
                    />
                  )} */}
                </Grid>
              </Grid>
              {renderAddRemoveIngredient(index)}
            </Grid>
          );
        })}
      </Box>
    </div>
  );
};
export default EventFaq;
